"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.start = exports.registerServiceWorker = exports.OuterApp = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _reactRouterDom = require("react-router-dom");
var _deviceContext = _interopRequireDefault(require("../universal/device-context"));
var _contexts = require("../universal/contexts");
var _app = _interopRequireDefault(require("../universal/components/_app"));
var _compatibility = require("../universal/compatibility");
var _switch = _interopRequireDefault(require("../universal/components/switch"));
var _routeComponent = require("../universal/components/route-component");
var _component = require("@loadable/component");
var _uuidv = require("../../utils/uuidv4.client");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/* global __webpack_require__ */

/* istanbul ignore next */
const registerServiceWorker = url => {
  return Promise.resolve().then(() => {
    if ('serviceWorker' in navigator) {
      return Promise.resolve().then(() => new Promise(resolve => window.addEventListener('load', resolve))).then(() => navigator.serviceWorker.register(url)).then(registration => console.log(`ServiceWorker registration successful with scope: ${registration.scope}`)).catch(err => console.log('ServiceWorker registration failed: ', err));
    }
  });
};
exports.registerServiceWorker = registerServiceWorker;
const OuterApp = ({
  routes,
  error,
  WrappedApp,
  locals
}) => {
  const AppConfig = (0, _compatibility.getAppConfig)();
  const isInitialPageRef = (0, _react.useRef)(true);
  return /*#__PURE__*/_react.default.createElement(_contexts.ServerContext.Provider, {
    value: {}
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_contexts.CorrelationIdProvider, {
    correlationId: () => {
      // If we are hydrating an error page use the server correlation id.
      if (isInitialPageRef.current && window.__ERROR__) {
        isInitialPageRef.current = false;
        return window.__INITIAL_CORRELATION_ID__;
      }
      return (0, _uuidv.uuidv4)();
    }
  }, /*#__PURE__*/_react.default.createElement(_deviceContext.default.Provider, {
    value: {
      type: window.__DEVICE_TYPE__
    }
  }, /*#__PURE__*/_react.default.createElement(AppConfig, {
    locals: locals
  }, /*#__PURE__*/_react.default.createElement(_switch.default, {
    error: error,
    appState: window.__PRELOADED_STATE__,
    routes: routes,
    App: WrappedApp
  }))))));
};
exports.OuterApp = OuterApp;
OuterApp.propTypes = {
  routes: _propTypes.default.array.isRequired,
  error: _propTypes.default.object,
  WrappedApp: _propTypes.default.func.isRequired,
  locals: _propTypes.default.object
};
/* istanbul ignore next */
const start = () => {
  const AppConfig = (0, _compatibility.getAppConfig)();
  const rootEl = document.getElementsByClassName('react-target')[0];
  const data = JSON.parse(document.getElementById('mobify-data').innerHTML);

  // Set all globals sent from the server on the window object.
  Object.entries(data).forEach(([key, value]) => {
    window[key] = value;
  });

  // Tell webpack how to find javascript files
  Object.defineProperty(__webpack_require__, 'p', {
    get: () => window.Progressive.buildOrigin
  });

  // On the browser we don't have request.locals, so we just provide an empty
  // object that exists for the lifetime of the app. AppConfig components can use
  // this to set up, eg. Redux stores.
  const locals = {};

  // AppConfig.restore *must* come before getRoutes()
  AppConfig.restore(locals, window.__PRELOADED_STATE__.__STATE_MANAGEMENT_LIBRARY);

  // We need to tell the routeComponent HOC when the app is hydrating in order to
  // prevent pages from re-fetching data on the first client-side render. The
  // reason we do this is that we expect a render to have taken place
  // on the server already. That server-side render already called getProps()
  // and froze the application state as a JSON blob on the page.
  //
  // This is VERY fiddly – don't go crazy with window.__HYDRATING__. You have
  // been warned.
  window.__HYDRATING__ = true;
  const props = {
    error: window.__ERROR__,
    locals: locals,
    routes: (0, _routeComponent.getRoutes)(locals),
    WrappedApp: (0, _routeComponent.routeComponent)(_app.default, false, locals)
  };
  return Promise.resolve().then(() => new Promise(resolve => (0, _component.loadableReady)(resolve))).then(() => {
    _reactDom.default.hydrate( /*#__PURE__*/_react.default.createElement(OuterApp, props), rootEl, () => {
      window.__HYDRATING__ = false;
    });
  });
};
exports.start = start;